import React from "react";
import useReveal from "@/hooks/useReveal";
import { useI18n } from "@/context/LangContext";

const STEPS = ["s1", "s2", "s3", "s4", "s5"];

export default function Process() {
  const ref = useReveal();
  const { t } = useI18n();
  return (
    <section id="process" ref={ref} data-testid="process" className="reveal section border-b border-[color:var(--line)] bg-[color:var(--paper-alt)]">
      <div className="container-x">
        <div className="mb-14 max-w-3xl">
          <div className="eyebrow">{t("process.eyebrow")}</div>
          <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02]">
            {t("process.title")}
          </h2>
        </div>
        <ol className="relative border-l border-[color:var(--ink)] pl-8 space-y-10">
          {STEPS.map((s, i) => (
            <li key={s} data-testid={`process-${s}`} className="relative">
              <span className="absolute -left-[42px] top-0 w-6 h-6 bg-[color:var(--brand)] text-white font-mono text-[11px] flex items-center justify-center">
                0{i + 1}
              </span>
              <h3 className="font-display font-bold text-xl">{t(`process.${s}.t`)}</h3>
              <p className="mt-2 text-neutral-700 max-w-2xl leading-relaxed">{t(`process.${s}.d`)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
